import { combineReducers } from "redux";
import * as isLoading from "./isLoading";
import * as share from "./share";
import * as shares from "./shares";

export const initialState = {
  isLoading: isLoading.initialState,
  share: null,
  shares: [],
};

export const reducer = combineReducers({
  isLoading: isLoading.reducer,
  share: share.reducer,
  shares: shares.reducer,
});

export interface StoreState {
  isLoading: isLoading.StoreState;
  share: share.StoreState;
  shares: shares.StoreState;
}
